import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getPAJAB020, putPAJAB020 } from '../../../services/Api';
import AddressCustom from '../../../shared/components/AddressCustom';
import Dropdown from '../../../shared/components/Dropdown';
import ImageCheckFallback from '../../../shared/components/ImageCheckFallback';
import ImageCropperBizImage from '../../../shared/components/ImageCropperBizImage';
import ImageCropperLogo from '../../../shared/components/ImageCropperLogo';
import SideNav from '../../../shared/components/SideNav';
import { decodeToken, handleFocus } from '../../../utils';
const PAJAB020 = () => {
    const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
    const [payload, setPayload] = useState([{ mapSvr: 'N', bizAddrDesc: '', regionDetail: '' }]);

    const [logo, setLogo] = useState(null);
    const [originalFileName, setOriginalFileName] = useState('');
    const [organizationImages, setOrganizationImages] = useState([]);
    const [organizationNewImages, setOrganizationNewImages] = useState([]);
    const [fileExists, setFileExists] = useState('');
    const [showCropper, setShowCropper] = useState(false);
    const [showLogoCropper, setShowLogoCropper] = useState(false);
    const [showOrgCropper, setShowOrgCropper] = useState(false);
    const navigate = useNavigate();

    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const memberID = decode.memberID;

    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, []);

    const handleComplete = (data) => {
        const { address, zonecode: postNo, roadAddress: addressRoad, bname: addressExtra } = data;
        setPayload((prevData) => ({ ...prevData, postNo, addressRoad, addressExtra, address }));
    };

    const handleSearchAddress = () => {
        setIsAddressModalOpen(true);
    };

    const getOptions = (name) => {
        const options = {
            BizType: [
                { option: '치과의원', value: '001' },
                { option: '치과병원', value: '002' },
                { option: '치과기공소', value: '003' },
                { option: '종합병원', value: '004' },
                { option: '네트워크치과', value: '005' },
                { option: '신규개원', value: '006' },
                { option: '일반(기타)', value: '999' },
            ],
        };

        return options[name];
    };

    const getListData = () => {
        getPAJAB020()
            .then(({ data }) => {
                setPayload(data);
                setLogo(data.logoName);
                setFileExists(data.subBizImg);

                if (data.subBizImg && data.subBizImg !== '') {
                    setOrganizationImages(data.subBizImg.split('|'));
                }
            })
            .catch((error) => console.log(error));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setPayload((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleOpenCropper = (imageType) => {
        if (imageType === 'logo') {
            setShowLogoCropper(true);
        } else {
            setShowOrgCropper(true);
        }
        setShowCropper(true);
    };

    useEffect(() => {
        if (!showCropper) {
            setShowLogoCropper(false);
            setShowOrgCropper(false);
        }
    }, [showCropper]);

    const handleCroppedImage = useCallback(
        (croppedImageUrl, croppedFile, imageType) => {
            setOriginalFileName(croppedFile.name);
            setShowCropper(false);

            if (imageType === 'logo') {
                setLogo({ url: croppedImageUrl, file: croppedFile, name: croppedFile.name });
            } else if (imageType === 'organization') {
                if (!croppedFile) return;

                const newImage = { url: croppedImageUrl, file: croppedFile, name: croppedFile.name };

                setOrganizationNewImages([...organizationNewImages, newImage]);
                setOrganizationImages([...organizationImages, newImage]);
            }
        },
        [organizationNewImages, organizationImages],
    );

    const handleDeleteImage = (index, imageType) => {
        if (!window.confirm('등록된 이미지를 삭제하시겠습니까?')) return;
        if (imageType === 'logo') {
            setLogo(null);
        } else if (imageType === 'organization') {
            const fileExitArray = fileExists.split('|');
            const imageNameToDelete = fileExitArray[index];

            const updatedFileExits = fileExitArray.filter((name) => name !== imageNameToDelete).join('|');

            setFileExists(updatedFileExits);

            const updatedOrganizationImages = organizationImages.filter((_, i) => i !== index);
            setOrganizationImages(updatedOrganizationImages);

            const updatedOrganizationNewImages = organizationNewImages.filter(
                (image) => image.name !== imageNameToDelete,
            );
            setOrganizationNewImages(updatedOrganizationNewImages);
        }
        alert('삭제되었습니다.');
    };

    const handleSave = () => {
        if (!payload?.bizCompany || payload?.bizCompany === '') {
            alert('치과명을 입력해 주세요.');
            handleFocus('bizCompany');
            return;
        } else {
            const allowedPattern = /^[\p{L}\p{N}\s\[\]\(\)\/\-&,\.]+$/u;
            if (!allowedPattern.test(payload?.bizCompany)) {
                alert('[ ] ( ) / - & , . 특수문자만 사용할 수 있습니다.');
                handleFocus('bizCompany');
                return;
            }
        }


        if (!payload?.bizType || payload?.bizType === '') {
            alert('사업장 구분을 선택해 주세요.');
            handleFocus('bizType');
            return;
        }
        if (!payload?.nameKor || payload?.nameKor === '') {
            alert('대표자명을 입력해 주세요.');
            handleFocus('nameKor');
            return;
        }

        if (!payload?.centerStaffCount || payload?.centerStaffCount === '') {
            alert('총 구성원수를 입력해 주세요.');
            handleFocus('centerStaffCount');
            return;
        }

        const confirm = window.confirm('저장하시겠습니까?');
        if (confirm) {
            const updatedPayload = { ...payload };

            updatedPayload.isDeleteLogo = 'N';

            const formData = new FormData();
            if (logo && logo.file instanceof Blob) {
                formData.append('logo', logo.file, originalFileName);
                console.log('logo appended');
            } else if (!logo) {
                updatedPayload.isDeleteLogo = 'Y';
            }

            formData.append('data', new Blob([JSON.stringify(updatedPayload)], { type: 'application/json' }));


            if (organizationNewImages.length > 0) {
                organizationNewImages.forEach((image) => {
                    if (image.file instanceof Blob) {
                        formData.append('subBizImg', image.file, image.name);
                    }
                });
            } else {
                formData.append('subBizImg', '');
            }
            console.log('updatedPayload:', updatedPayload);

            formData.append('fileExists', fileExists);


            putPAJAB020(formData)
                .then(() => {
                    window.alert('저장되었습니다.');
                    navigate('/pajab010');
                })
                .catch((error) => console.log(error));
        }
    };

    const handleCancel = () => {
        const confirm = window.confirm('저장하지 않고 페이지를 나가시겠습니까?');
        if (confirm) {
            navigate('/pajab010');
        }
    };

    return (
        <>
            <div id="content" className="sub-page">
                <div className="container">
                    <div id="top-sub-page">
                        <SideNav />
                        <div className="resume">
                            <div className="resume__inner">
                                <h3 className="resume__tit">치과 정보 관리</h3>
                                <div className="rsm-dtl">
                                    <div className="resume__tit-box resume__tit-box--between mb12">
                                        <h4 className="resume__tit2">치과 정보</h4>
                                        <p className="dntInf__ps">
                                            * 대표자명 변경을 희망하신다면 고객센터로 문의주세요.
                                        </p>
                                    </div>
                                    <table className="rsm-dtl__table rsm-dtl__table--ver2 wd160 modify">
                                        <tbody>
                                            <tr>
                                                <th>
                                                    치과명<span className="required">*</span>
                                                </th>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="dntInf__input"
                                                        name="bizCompany"
                                                        value={payload?.bizCompany || ''}
                                                        onChange={handleInputChange}
                                                        maxLength={50}
                                                    />
                                                </td>
                                                <th>
                                                    사업장 구분<span className="required">*</span>
                                                </th>
                                                <td className="wd36per">
                                                    <div className="dntInf__select">
                                                        <div className="form-select-container">
                                                            <Dropdown
                                                                placeholder="사업장구분 선택"
                                                                options={getOptions('BizType')}
                                                                name="bizType"
                                                                id="bizType"
                                                                value={payload?.bizType || ''}
                                                                openUpwards={false}
                                                                className="select-nameClass"
                                                                onChange={(valueOption) => {
                                                                    handleInputChange({
                                                                        target: { name: 'bizType', value: valueOption },
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    대표자명<span className="required">*</span>
                                                </th>
                                                <td>{payload?.nameKor}</td>
                                                <th>홈페이지</th>
                                                <td colSpan={3}>
                                                    <input
                                                        type="text"
                                                        className="dntInf__input wd-full"
                                                        name="homepageUrl"
                                                        value={payload?.homepageUrl || ''}
                                                        onChange={handleInputChange}
                                                        maxLength={100}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>주소</th>
                                                <td colSpan={3}>
                                                    <div className="dntInf__col">
                                                        <div className="dntInf__adr">
                                                            <input
                                                                type="text"
                                                                className="dntInf__input"
                                                                name="postNo"
                                                                value={payload?.postNo || ''}
                                                                readOnly
                                                            />
                                                            <button type="button" onClick={handleSearchAddress}>
                                                                주소찾기
                                                            </button>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="dntInf__input"
                                                            value={payload.addressRoad || ''}
                                                            readOnly
                                                        />
                                                        <input
                                                            type="text"
                                                            className="dntInf__input"
                                                            name="addressDetail"
                                                            value={payload.addressDetail || ''}
                                                            onChange={handleInputChange}
                                                            maxLength={100}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div className="resume__tit-box mb12">
                                        <h4 className="resume__tit2">치과 소개</h4>
                                    </div>
                                    <table className="rsm-dtl__table rsm-dtl__table--ver2 wd160 modify">
                                        <tbody>
                                            <tr>
                                                <th>치과 로고</th>
                                                <td>
                                                    <div className="dntInf__glr">
                                                        <div className="dntInf__file">
                                                            <label
                                                                className="dntInf__upload-btn"
                                                                htmlFor="logoUpload"
                                                                onClick={() => handleOpenCropper('logo')}
                                                            />
                                                            {showLogoCropper && (
                                                                <ImageCropperLogo
                                                                    isOpen={showCropper}
                                                                    onClose={() => setShowCropper(false)}
                                                                    onCrop={handleCroppedImage}
                                                                    imageType="logo"
                                                                    memberID={memberID}
                                                                />
                                                            )}
                                                        </div>
                                                        <div className="dntInf__imgbox dntInf__imgbox--logo">
                                                            {logo && (
                                                                <>
                                                                    <ImageCheckFallback
                                                                        folderName={'recruit_logo'}
                                                                        imgName={logo}
                                                                        src={logo.url}
                                                                        alt="Recruit Logo"
                                                                        classImg={'dntInf__logo'}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="dntInf__delet"
                                                                        onClick={() => handleDeleteImage(0, 'logo')}
                                                                    />
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    치과 이미지{' '}
                                                    <div className="rgst__desc mt10">
                                                        *최대 4개까지
                                                        <br /> 등록 가능합니다.
                                                    </div>
                                                </th>
                                                <td>
                                                    <div className="dntInf__glr">
                                                        <div className="dntInf__file">
                                                            <label
                                                                className="dntInf__upload-btn"
                                                                htmlFor="organizationUpload"
                                                                onClick={() => {
                                                                    if (organizationImages.length >= 4) {
                                                                        alert('최대 4개까지 등록 가능합니다.');
                                                                        return;
                                                                    }
                                                                    handleOpenCropper('organization');
                                                                }}
                                                            />
                                                            {showOrgCropper && (
                                                                <ImageCropperBizImage
                                                                    isOpen={showCropper}
                                                                    onClose={() => setShowCropper(false)}
                                                                    onCrop={handleCroppedImage}
                                                                    imageType="organization"
                                                                    memberID={memberID}
                                                                />
                                                            )}
                                                        </div>

                                                        {organizationImages.length > 0 &&
                                                            organizationImages.map((image, index) => (
                                                                <div className="dntInf__imgbox" key={index}>
                                                                    <ImageCheckFallback
                                                                        folderName={'recruit_photo'}
                                                                        imgName={image}
                                                                        src={image.url}
                                                                        alt="Recruit Organization"
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        className="dntInf__delet"
                                                                        onClick={() =>
                                                                            handleDeleteImage(index, 'organization')
                                                                        }
                                                                    />
                                                                </div>
                                                            ))}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    총 구성원수<span className="required">*</span>
                                                </th>
                                                <td>
                                                    <input
                                                        type="text"
                                                        className="dntInf__input"
                                                        value={payload.centerStaffCount || ''}
                                                        name="centerStaffCount"
                                                        onChange={handleInputChange}
                                                        maxLength={50}
                                                        style={{ width: '110px' }}
                                                    />{' '}
                                                    명
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>구성원 설명</th>
                                                <td>
                                                    <textarea
                                                        name="memberDesc"
                                                        id="memberDesc"
                                                        className="dntInf__textarea full"
                                                        onChange={handleInputChange}
                                                        value={payload.memberDesc || ''}
                                                        maxLength={200}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>치과소개</th>
                                                <td className="hi260">
                                                    <textarea
                                                        name="centerDesc"
                                                        id="centerDesc"
                                                        className="dntInf__textarea full"
                                                        onChange={handleInputChange}
                                                        value={payload.centerDesc || ''}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div className="dntInf__btbx">
                                        <button className="dntInf__btn dntInf__btn--black" onClick={handleCancel}>
                                            취소
                                        </button>
                                        <button type="button" className="dntInf__btn" onClick={handleSave}>
                                            치과정보 수정
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddressCustom
                isOpen={isAddressModalOpen}
                onClose={() => setIsAddressModalOpen(false)}
                onComplete={handleComplete}
            />
        </>
    );
};
export default PAJAB020;
